<template>
  <div class="home">
    <landing />

    <About />

    <Skills />

    <Jobs />
  </div>
</template>

<script>
import Landing from "../components/portfolio/Landing.vue";
import Jobs from "../components/portfolio/Jobs.vue";
import About from "../components/portfolio/About.vue";
import Skills from "../components/portfolio/Skills.vue";
// @ is an alias to /src
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
export default {
  name: "Home",
  components: {
    Landing,
    Jobs,
    About,
    Skills,
  },
  setup() {
    const siteData = reactive({
      title: `Barakadev | home`,
      description: `My beautiful website`,
    });
    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
      ],
    });
  },
};
</script>
<style>
.home {
  min-height: 100vh;
  /* margin-top: 50px; */
  /* margin-bottom: 55px; */
}
</style>
